import React from 'react'
import block from 'bem-cn'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import { Icon } from 'components/UIKit/Icon'
import { UsePaginationReturn } from 'components/UIKit/Table'

import './MobilePagination.scss'

export type MobilePaginationProps = {
  isFixed?: boolean
  isDisabled?: boolean
  pagination: UsePaginationReturn
}

const b = block('mobile-pagination')

export const MobilePagination: React.FC<MobilePaginationProps> = ({ isFixed, pagination, isDisabled }) => {
  const { t } = useAppTranslation()

  return (
    <div className={b('pagination', { isFixed })}>
      <button
        type="button"
        className={b('pagination-button')}
        disabled={!pagination.hasPrevious || isDisabled}
        onClick={pagination.onPrevPage}>
        <Icon type="arrow" className={b('pagination-arrow').mix('left')} />
      </button>

      <div className={b('pagination-text')}>
        {t('common.pagination.pageInfo', { page: pagination.page, totalPages: pagination.totalPages })}
      </div>

      <button
        type="button"
        className={b('pagination-button')}
        disabled={!pagination.hasNext || isDisabled}
        onClick={pagination.onNextPage}>
        <Icon type="arrow" className={b('pagination-arrow').mix('right')} />
      </button>
    </div>
  )
}
